import { businessunitsTypes } from "../constantes/actionTypes"

const initialState = []

export const businessunits = (state = initialState, action) => {
    switch (action.type) {
        case businessunitsTypes.GET_ALL_BUSINESSUNITS_SUCCESS:
            return action.payload
        case businessunitsTypes.GET_ALL_BUSINESSUNITS_FAILURE:
            return initialState
        default:
            return state
    }
}